import { useContext } from 'react';
import { HookFormContext } from 'components/cef_form/hook-form/providers/HookFormProvider';
import HookFormTextInput from 'components/cef_form/hook-form/HookFormTextInput';
import { DOB_YEAR_REGEX } from 'constants/constants';

const HookFormDobInput = () => {
  const {
    watchedFields: { dateOfBirth },
    errors,
    setError,
    clearErrors,
  } = useContext(HookFormContext);

  const valiDate = () => {
    // Correctly format users input for Date func
    const usersDate = `${dateOfBirth.year}/${dateOfBirth.month}/${dateOfBirth.day}`;

    // Create a new date object
    const dateObj = new Date(usersDate);

    // Check if any fields are empty
    const dobFieldEmpty = Object.values(dateOfBirth).some(value => !value);

    // if empty show main entry error
    if (dobFieldEmpty) {
      setError('dateOfBirthEntered', {
        type: 'custom',
        message: 'Please enter your date of birth',
      });
      /**
       * Date function automatically corrects incorrect dates so
       * if a user enters 31/02 Date corrects this to 02/03
       * Date also works on a 0 index, to correct this we -1 from users Month
       * if the months dont match show valid date of birth error
       */
    } else if (dateObj.getMonth() !== dateOfBirth.month - 1) {
      setError('dateOfBirthEntered', {
        type: 'custom',
        message: 'Please enter a valid date of birth',
      });
    } else {
      clearErrors('dateOfBirthEntered');
    }
  };

  const options = [
    {
      id: 'date_of_birth.day',
      placeholder: 'DD',
      label: 'day',
      rules: {
        minLength: {
          value: 2,
          message: 'Day must be at least 2 characters long',
        },
      },
      value: dateOfBirth.day,
    },
    {
      id: 'date_of_birth.month',
      placeholder: 'MM',
      label: 'month',
      rules: {
        minLength: {
          value: 2,
          message: 'Month must be at least 2 characters long',
        },
      },
      className: 'ml-12 mr-12',
      value: dateOfBirth.month,
    },
    {
      id: 'date_of_birth.year',
      placeholder: 'YYYY',
      label: 'year',
      rules: {
        minLength: {
          value: 4,
          message: 'Year must be 4 characters long',
        },
        pattern: {
          value: DOB_YEAR_REGEX,
          message: 'Year must be from 1930',
        },
      },
      value: dateOfBirth.year,
    },
  ];

  return (
    <div className="cef-ui-text-input mt-20">
      <div
        className={`fl fl-col ${
          (errors.date_of_birth &&
            Object.keys(errors.date_of_birth)?.some(date => date)) ||
          errors.dateOfBirthEntered
            ? 'has-error'
            : ''
        }`}>
        <legend className="cef-ui-legend">
          <div className="cef-ui-legend__title">Date of Birth</div>
        </legend>

        <div className="fl">
          {options.map(
            ({ id, placeholder, label, className, rules, value }) => (
              <HookFormTextInput
                key={label}
                id={id}
                type="text"
                label={label}
                placeholder={placeholder}
                className={`cef-ui-text-input-field--date cef-ui-text-input-field--date--${label} ${
                  className || ''
                }`}
                rules={{
                  ...rules,
                  validate: valiDate,
                }}
                value={value}
              />
            ),
          )}
        </div>
      </div>

      {errors.dateOfBirthEntered && (
        <div className="cef-ui-input-error cef-ui-input__error">
          {errors.dateOfBirthEntered.message}
        </div>
      )}

      {/**
       * Specific errors for DD MM YYYY
       * Currently this is only needed for Year
       * but we're ready if we ever want errors for Day/Month
       */}
      {errors?.date_of_birth &&
        Object.values(errors?.date_of_birth).map(error => (
          <div
            key={error?.ref.name}
            className="cef-ui-input-error cef-ui-input__error">
            {error?.message}
          </div>
        ))}
    </div>
  );
};

export default HookFormDobInput;
